import { Component, Input, ViewChild } from '@angular/core';
import { ExportDropdownMenuItem } from '../export/export-dropdown/export-dropdown-menu-item';
import { MatMenuTrigger } from '@angular/material/menu';
import { DropdownMenuItem } from './dropdown-menu-item';

@Component({
  selector: 'app-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
})
export class DropdownMenuComponent {
  @Input() disabled = false;

  @Input() menuItems: DropdownMenuItem[] = [];

  @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;

  private loadingMenuItemIds: string[] = [];

  public onMenuItemClick(menuItem: ExportDropdownMenuItem, $event: MouseEvent): void {
    $event.stopPropagation();
    this.markMenuItemAsLoading(menuItem);

    menuItem.action().finally(() => {
      this.markMenuItemAsNotLoading(menuItem);
      this.closeMenuIfNoItemsAreLoading();
    });
  }

  public isMenuItemLoading(menuItem: ExportDropdownMenuItem): boolean {
    return this.loadingMenuItemIds.some((loadingListItemId) => loadingListItemId === menuItem.id);
  }

  public getMenuItemLabels(): string[] {
    return this.menuItems.map((item) => item.text);
  }

  /*
   * NgIf goes haywire when iterating over anything with an anonymous function returning promises.
   * Thus, this workaround.
   */
  public getMenuItemByIndex(index: number): ExportDropdownMenuItem {
    return this.menuItems[index];
  }

  private markMenuItemAsLoading(menuItem: ExportDropdownMenuItem): void {
    this.loadingMenuItemIds.push(menuItem.id);
  }

  private markMenuItemAsNotLoading(menuItem: ExportDropdownMenuItem): void {
    this.loadingMenuItemIds = this.loadingMenuItemIds.filter((id) => id !== menuItem.id);
  }

  private closeMenuIfNoItemsAreLoading(): void {
    if (this.loadingMenuItemIds.length === 0) {
      this.menuTrigger.closeMenu();
    }
  }
}
